import { kebabToCamel } from './utils';

/**
 * Initialize component using Drupal behaviors.
 */
export default function init(Drupal, name, selector, attach) {
  Drupal.behaviors[name] = {
    attach: (context, settings) => {
      context.querySelectorAll(selector).forEach(elem => {
        const processedClass = 'component--processed';

        if (elem.classList.contains(processedClass)) return;

        const data = {};
        [...elem.attributes].forEach(({ name: attrName, value }) => {
          if (attrName.startsWith('data-')) {
            try {
              value = JSON.parse(value);
            } catch (e) {}
            data[kebabToCamel(attrName.replace('data-', ''))] = value;
          }
        });

        attach(elem, data, settings);
        elem.classList.add(processedClass);
      });
    },
  };
}
